import ChipStandard from 'asterX-UI/DataDisplay/ChipStandard'
import { GRAY_COLORS, PRIMARY_COLORS, SUCCESS_COLORS } from 'asterX-UI'
import { FieldInfoNG } from 'asterX-UI/DataDisplay'
import moment from 'moment/moment'
import { Button, Divider, makeStyles } from '@material-ui/core'
import React from 'react'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4
  },
  title: {
    color: GRAY_COLORS[800],
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px'
  },
  carCard: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 12,
    flexWrap: 'nowrap',
    alignItems: 'flex-start'
  },
  carPhoto: {
    width: 200,
    height: 150,
    borderRadius: 16
  },
  carInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: '100%'
  },
  carInfoRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 6
  },
  carTitle: {
    color: GRAY_COLORS[800],
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '18px'
  },
  priceBlock: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
    padding: '12px 16px',
    borderRadius: 12,
    border: `1px solid ${GRAY_COLORS[300]}`
  }
}))

const fontInfo = {
  fontSize: 12
}

export const SppWorkListEstimateCardMobile = ({ assessment, isLast }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <div className={classes.title}>{`Оценка №${assessment.id}`}</div>
        <div>
          <ChipStandard
            color={PRIMARY_COLORS[700]}
            backgroundColor={PRIMARY_COLORS[50]}
          >
            {assessment?.carStatusesName}
          </ChipStandard>
        </div>
      </div>
      <div className={classes.carCard}>
        <div className={classes.carPhoto}>
          <img
            src={assessment?.coverPhoto}
            className={classes.carPhoto}
            alt={'car'}
          />
        </div>
        <div className={classes.carInfo}>
          <div className={classes.carInfoRow}>
            <div
              className={classes.carTitle}
            >{`${assessment?.markaName} ${assessment?.modelName} ${assessment?.year}`}</div>
          </div>
          <div className={classes.carInfoRow}>
            <FieldInfoNG
              label={'VIN-код'}
              isVertical
              rootStyle={{
                width: '100%'
              }}
              labelStyle={fontInfo}
              style={fontInfo}
            >
              {assessment?.vin || '-'}
            </FieldInfoNG>
          </div>
          <div className={classes.carInfoRow}>
            <FieldInfoNG
              label={'Дата созд-я оценки'}
              isVertical
              rootStyle={{
                width: '100%'
              }}
              labelStyle={fontInfo}
              style={fontInfo}
            >
              {assessment?.createdDate
                ? moment(assessment?.createdDate).format('DD MMM YYYY')
                : '-'}
            </FieldInfoNG>
          </div>
          <div className={classes.carInfoRow}>
            <FieldInfoNG
              label={'ФИО закупщика'}
              isVertical
              rootStyle={{
                width: '100%'
              }}
              labelStyle={fontInfo}
              style={fontInfo}
            >
              {assessment?.createdByFullname || '-'}
            </FieldInfoNG>
          </div>
        </div>
      </div>
      <div className={classes.priceBlock}>
        <FieldInfoNG
          label={'Первичная оценка'}
          isVertical
          rootStyle={{
            width: '49%'
          }}
          labelStyle={{ ...fontInfo, color: GRAY_COLORS[700] }}
          style={{
            color: SUCCESS_COLORS[600],
            fontSize: 18,
            fontWeight: 500
          }}
        >
          {assessment?.initialPrice
            ? `${assessment?.initialPrice?.toString()?.thousandSeparator()} ₸`
            : '-'}
        </FieldInfoNG>
        <FieldInfoNG
          label={'Ожидания клиента'}
          isVertical
          rootStyle={{
            width: '49%'
          }}
          labelStyle={{ ...fontInfo, color: GRAY_COLORS[700] }}
          style={{
            fontSize: 18,
            fontWeight: 500
          }}
        >
          {assessment?.clientExpectation
            ? `${assessment?.clientExpectation
                ?.toString()
                ?.thousandSeparator()} ₸`
            : '-'}
        </FieldInfoNG>
      </div>
      <Button variant={'contained'} color={'primary'} fullWidth>
        Результат оценки
      </Button>
      {!isLast && (
        <Divider
          style={{
            marginTop: 12,
            marginBottom: 12
          }}
        />
      )}
    </div>
  )
}
